import { Box, Button, Grid2, Modal, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { viewPDF } from "../../../utils/viewPDF";
import { useParams } from "react-router-dom";
import axios from "axios";
import html2pdf from "html2pdf.js";
import SuccessModal from "../../../utils/SuccessModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PreviewDetails = ({ qDetails, setStep, storedUser, fileNames }) => {
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { tenderId } = useParams();
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  const handleSubmit = async () => {
    if (loading) return;
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vtq`,
        {
          vendorId: vendorId,
          tenderId: tenderId,
          name: qDetails.name,
          mobile: qDetails.mobile,
          email: qDetails.email,
          address: qDetails.address,
          businessRegistration: qDetails.businessRegistration,
          pan: qDetails.pan,
          gstin: qDetails.gstin,
          bankName: qDetails.bankName,
          accountNumber: qDetails.accountNumber,
          ifsc: qDetails.ifsc,
          accountType: qDetails.accountType,
          isMSME: qDetails.isMSME,
          businessLicense: qDetails.businessLicense,
          insurance: qDetails.insurance,
          compliance: qDetails.compliance,
          bankAccount: qDetails.bankAccount,
          serviceOffered: qDetails.serviceOffered,
          deliveryTerms: qDetails.deliveryTerms,
          paymentTerms: qDetails.paymentTerms,
          clientReference: qDetails.clientReference,
          performanceHistory: qDetails.performanceHistory,
          certifications: qDetails.certifications,
          dataProtection: qDetails.dataProtection,
          securityMeasures: qDetails.securityMeasures,
          financialStatements: qDetails.financialStatements,
          bankStatements: qDetails.bankStatements,
          others: qDetails.others,
          businessRegistrationFilename: fileNames.businessRegistration,
          businessLicenseFilename: fileNames.businessLicense,
          insuranceFilename: fileNames.insurance,
          complianceFilename: fileNames.compliance,
          bankAccountFilename: fileNames.bankAccount,
          clientReferenceFilename: fileNames.clientReference,
          performanceHistoryFilename: fileNames.performanceHistory,
          certificationsFilename: fileNames.certifications,
          dataProtectionFilename: fileNames.dataProtection,
          securityMeasuresFilename: fileNames.securityMeasures,
          financialStatementsFilename: fileNames.financialStatements,
          bankStatementsFilename: fileNames.bankStatements,
          othersFilename: fileNames.others,
        },
        {
          headers: {
            Authorization: `Bearer ${storedUser.accessToken}`,
          },
        }
      );
      localStorage.removeItem("form");
      setOpenConfirm(false);
      setOpen(true);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const pdfRef = useRef();

  const handleExportPDF = () => {
    const pdfContainer = pdfRef.current;

    // Add a class for PDF-specific styling
    pdfContainer.classList.add("pdf-mode");

    html2pdf()
      .from(pdfContainer)
      .set({
        margin: 10,
        filename: "Vendor_Qualification_Details.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { format: "a4", orientation: "portrait" },
      })
      .save()
      .then(() => {
        // Remove the PDF-specific class after export
        pdfContainer.classList.remove("pdf-mode");
      });
  };
  return (
    <div style={{ position: "relative" }}>
      {loading && <div className="loading-div"></div>}
      <Typography variant="h4">Vender Qualification Preview</Typography>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button className="btn-contained" onClick={handleExportPDF}>
          Export PDF
        </Button>
      </div>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10} py={7}>
          <Typography className="form-title">Basic Information</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Vendor Name (as per government ID)
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.name}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Phone Number
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.mobile}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Email ID
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.email}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Business Registration Certificates
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.businessRegistration && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() =>
                    viewPDF(qDetails.businessRegistration, storedUser)
                  }
                >
                  {qDetails.businessRegistrationFilename ||
                    fileNames.businessRegistration}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">Financial Information</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              PAN
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.pan}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              GSTIN
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.gstin}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Name
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.bankName}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Account Number
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.accountNumber}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              IFSC Code
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.ifsc}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Account Type
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.accountType}
            </Grid2>
          </Grid2>

          <Typography className="form-title">Compliance and Legal</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Business License
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.businessLicense && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.businessLicense, storedUser)}
                >
                  {qDetails.businessLicenseFilename ||
                    fileNames.businessLicense}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Insurance Certificates
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.insurance && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.insurance, storedUser)}
                >
                  {qDetails.insuranceFilename || fileNames.insurance}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Compliance with industry-specific regulations
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.compliance && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.compliance, storedUser)}
                >
                  {qDetails.complianceFilename || fileNames.compliance}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Account Details
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.bankAccount && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.bankAccount, storedUser)}
                >
                  {qDetails.bankAccountFilename || fileNames.bankAccount}
                </Button>
              )}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Do you belong to MSME?
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.isMSME ? "Yes" : "No"}
            </Grid2>
          </Grid2>

          <Typography className="form-title">Operational Details</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Products/Services Offered
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.serviceOffered}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Delivery Terms
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.deliveryTerms}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Payment Terms
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.paymentTerms}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            References and Performance
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Client References
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.clientReference && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.clientReference, storedUser)}
                >
                  {qDetails.clientReferenceFilename ||
                    fileNames.clientReference}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Performance History
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.performanceHistory && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() =>
                    viewPDF(qDetails.performanceHistory, storedUser)
                  }
                >
                  {qDetails.performanceHistoryFilename ||
                    fileNames.performanceHistory}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Certifications and Accreditations
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.certifications && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.certifications, storedUser)}
                >
                  {qDetails.certificationsFilename || fileNames.certifications}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            Security and Data Protection
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Data Protection Policies
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.dataProtection && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.dataProtection, storedUser)}
                >
                  {qDetails.dataProtectionFilename || fileNames.dataProtection}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Security Measures in Place
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.securityMeasures && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.securityMeasures, storedUser)}
                >
                  {qDetails.securityMeasuresFilename ||
                    fileNames.securityMeasures}
                </Button>
              )}
            </Grid2>
          </Grid2>

          <Typography className="form-title">
            Additional Documentation
          </Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              Audited Financial Statements
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {qDetails && qDetails.financialStatements && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() =>
                    viewPDF(qDetails.financialStatements, storedUser)
                  }
                >
                  {qDetails.financialStatementsFilename ||
                    fileNames.financialStatements}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Bank Statements
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.bankStatements && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.bankStatements, storedUser)}
                >
                  {qDetails.bankStatementsFilename || fileNames.bankStatements}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Any other relevant documents as per company policy
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {qDetails && qDetails.others && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(qDetails.others, storedUser)}
                >
                  {qDetails.othersFilename || fileNames.others}
                </Button>
              )}
            </Grid2>
          </Grid2>
        </Box>
      </div>

      <Box className="btn-container" sx={{ gap: 5 }}>
        <Button className="btn-outlined" sx={{ px: 7 }} onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          sx={{ px: 7 }}
          onClick={() => setOpenConfirm(true)}
        >
          Submit
        </Button>
      </Box>

      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpenConfirm(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <SuccessModal
        open={open}
        handleClose={handleClose}
        msg={"Qualification details submitted!"}
        nav={"/vendor/dashboard"}
      />
    </div>
  );
};

export default PreviewDetails;
